// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"style_inputWrapper__1-Ouc","inputSingleColumnWrapper":"style_inputSingleColumnWrapper__2uIBY","inputDoubleColumnWrapper":"style_inputDoubleColumnWrapper__q-gQQ"};